/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * サービスプロジェクト役務情報
 * @export
 * @interface ServiceProjectPolicyResponse
 */
export interface ServiceProjectPolicyResponse {
    /**
     * アクセスポイント
     * @type {string}
     * @memberof ServiceProjectPolicyResponse
     */
    'access_point'?: string;
    /**
     * サービスプロジェクト利用許可役務有無 - ENABLED:サービス利用許可役務あり（画面表示ありで活性） - DISABLED:サービス利用許可役務なし（画面表示ありで非活性） - HIDDEN: サービス利用許可役務なし（画面表示なし） 
     * @type {string}
     * @memberof ServiceProjectPolicyResponse
     */
    'service_project_policy'?: ServiceProjectPolicyResponseServiceProjectPolicyEnum;
    /**
     * サービスメニューボタン表示名
     * @type {string}
     * @memberof ServiceProjectPolicyResponse
     */
    'service_menu_button_display_name'?: string;
    /**
     * 遷移先URL
     * @type {string}
     * @memberof ServiceProjectPolicyResponse
     */
    'url'?: string;
}

export const ServiceProjectPolicyResponseServiceProjectPolicyEnum = {
    Enabled: 'ENABLED',
    Disabled: 'DISABLED',
    Hidden: 'HIDDEN'
} as const;

export type ServiceProjectPolicyResponseServiceProjectPolicyEnum = typeof ServiceProjectPolicyResponseServiceProjectPolicyEnum[keyof typeof ServiceProjectPolicyResponseServiceProjectPolicyEnum];


